//import Images
import avatar1 from "assets/images/users/avatar-1.jpg";
import avatar2 from "assets/images/users/avatar-2.jpg";
import avatar3 from "assets/images/users/avatar-3.jpg";
import avatar4 from "assets/images/users/avatar-4.jpg";
import avatar5 from "assets/images/users/avatar-5.jpg";
import avatar6 from "assets/images/users/avatar-6.jpg";
import avatar7 from "assets/images/users/avatar-7.jpg";
import avatar8 from "assets/images/users/avatar-8.jpg";
import avatar9 from "assets/images/users/avatar-9.jpg";
import avatar10 from "assets/images/users/avatar-10.jpg";
import avatar11 from "assets/images/users/user-dummy-img.jpg";

import productImg1 from "assets/images/products/img-119.jpg"
import productImg3 from "assets/images/products/img-3.png"
import productImg4 from "assets/images/products/img-4.png"
import productImg5 from "assets/images/products/img-120.png"
import productImg6 from "assets/images/products/img-121.jpg"
import productImg7 from "assets/images/products/img-122.jpg"
import productImg8 from "assets/images/products/img-123.jpeg"
import productImg9 from "assets/images/products/img-107.jpg"

import { axiosInstance } from '../../helpers/api_helper';

interface RecentOrders {
    catName: any;
    productCategories: any;
    orderID: any;
    id: number;
    purchaseID: string;
    customerName: string;
    vendorName: string;
    productImage: string; // Update the type based on the actual data type
    productName: string;
    orderDate: string;
    orderStatus: number;
    fullName: string;
    rating: number;
    avatar: string;
}

const authUser = localStorage.getItem('authUser');
const { vendorID } = authUser ? JSON.parse(authUser) : { vendorID: '' };


async function fetchRecentOrdersList(): Promise<RecentOrders[]> {

    //const apiUrl = `/Vendor/VendorOrders/${vendorID}`;

    const userId = '5416823f-b6c5-4f42-a0b6-482c3c1091e5';
    const apiUrl = `/Vendor/VendorOrders/${vendorID}`;

    try {
        const response = await axiosInstance.get(apiUrl);

        // Log the entire response
        console.log('API Response:', response);
        console.log('API Order List Response Data:', response.data);

        // Map the API response data to include the avatar property
        const recentOrders: RecentOrders[] = response.data.map((order: any) => ({
            ...order,
            avatar: avatar11,
        }));

        return recentOrders;
    } catch (error: any) {
        console.error('Error:', error.message);
        // Handle errors here
        throw error; 
    }
}

export { fetchRecentOrdersList };

const recentOrders = [
    {
        id: 1,
        purchaseID: "#TB010338",
        customerName: "Aircraft Engines",
        productImage: avatar2,
        productName: "Terry White",
        amount: "$658.00",
        orderDate: "28 Oct, 2022",
        deliveryDate: '26 Jan, 2023',
        vendor: "Brazil",
        rating: 4.5,
        status: "Paid"
    },
    {
        id: 2,
        purchaseID: "#TB010337",
        customerName: "Navigation System",
        productImage: avatar2,
        productName: "Terry White",
        amount: "$658.00",
        orderDate: "30 Oct, 2022",
        deliveryDate: '28 Jan, 2023',
        vendor: "Brazil",
        rating: 4.8,
        status: "Paid"
    },
    {
        id: 3,
        purchaseID: "#TB010336",
        customerName: "Wing",
        productImage: avatar8,
        productName: "Heather Jimenez",
        amount: "$741.98",
        orderDate: "02 Nov, 2022",
        deliveryDate: '29 Dec, 2022',
        vendor: "Spain",
        rating: 4.3,
        status: "Paid"
    },
    {
        id: 4,
        purchaseID: "#TB010335",
        customerName: "Avionics Panel",
        productImage: avatar9,
        productName: "Scott Wilson",
        amount: "$264.37",
        orderDate: "01 Nov, 2022",
        deliveryDate: '13 Dec, 2022',
        vendor: "Jersey",
        rating: 3.9,
        status: "Unpaid"
    }, {
        id: 5,
        purchaseID: "#TB010334",
        customerName: "Landing Gear",
        productImage: avatar10,
        productName: "Ashley Silva",
        amount: "$349.99",
        orderDate: "31 Oct, 2022",
        deliveryDate: '03 Dec, 2022',
        vendor: "Argentina",
        rating: 4.7,
        status: "Pending"
    },
    {
        id: 6,
        purchaseID: "#TB010333",
        customerName: "Windshields",
        productImage: avatar3,
        productName: "Stephen Bird",
        amount: "$80.00",
        orderDate: "30 Oct, 2022",
        deliveryDate: '12 Nov, 2022',
        vendor: "USA",
        rating: 4.4,
        status: "Paid"
    },
    {
        id: 7,
        purchaseID: "#TB010332",
        customerName: "Navigation System",
        productImage: avatar4,
        productName: "Daniel Gonzalez",
        amount: "$345.00",
        orderDate: "29 Oct, 2022",
        deliveryDate: '11 Nov, 2022',
        vendor: "Namibia",
        rating: 4.4,
        status: "Unpaid"
    },
    {
        id: 8,
        purchaseID: "#TB010331",
        customerName: "Aircraft Engine",
        productImage: avatar2,
        productName: "Terry White",
        amount: "$658.00",
        orderDate: "28 Oct, 2022",
        deliveryDate: '09 Nov, 2022',
        vendor: "Brazil",
        rating: 4.7,
        status: "Paid"
    }
];

const stockReport = [
    {
        productID: "#00541",
        productImage: productImg1,
        productName: "Aircraft Engine",
        updatedDate: "16 Aug, 2022",
        amount: "$658.00",
        stockStatus: "In Stock",
        quantity: "15 PCS"
    },
    {
        productID: "#07484",
        productImage: productImg5,
        productName: "Navigation System",
        updatedDate: "05 Sep, 2022",
        amount: "$145.00",
        stockStatus: "Low Stock",
        quantity: "05 PCS"
    },
    {
        productID: "#01641",
        productImage: productImg6,
        productName: "Wing",
        updatedDate: "28 Sep, 2022",
        amount: "$215.00",
        stockStatus: "Out of Stock",
        quantity: "0 PCS"
    },
    {
        productID: "#00065",
        productImage: productImg7,
        productName: "Avionics Panel",
        updatedDate: "02 Oct, 2022",
        amount: "$79.99",
        stockStatus: "In Stock",
        quantity: "37 PCS"
    },
    {
        productID: "#00156",
        productImage: productImg8,
        productName: "Landing Gear",
        updatedDate: "11 Oct, 2022",
        amount: "$264.99",
        stockStatus: "In Stock",
        quantity: "23 PCS"
    },
    {
        productID: "#09102",
        productImage: productImg9,
        productName: "Windshields",
        updatedDate: "19 Nov, 2022",
        amount: "$264.99",
        stockStatus: "Low Stock",
        quantity: "23 PCS"
    },
];

const productDelivery = [
    {
        id: 1,
        productImage: productImg8,
        productName: "Men's Running Shoes Activ...",
        productBy: "Aisha Bradley",
        productStatus: "Shipping",
        badgeColor: "warning",
    },
    {
        id: 2,
        productImage: productImg4,
        productName: "Striped Baseball Cap",
        productBy: "Edgar Bailey",
        productStatus: "Delivered",
        badgeColor: "success",
    },
    {
        id: 3,
        productImage: productImg3,
        productName: "350 ml Glass Groce...",
        productBy: "Adam Small",
        productStatus: "Out of Delivery",
        badgeColor: "danger",
    },
    {
        id: 4,
        productImage: productImg6,
        productName: "Monte Carlo Sweaters",
        productBy: "Evie Merrill",
        productStatus: "Delivered",
        badgeColor: "success",
    },
    {
        id: 5,
        productImage: productImg9,
        productName: "Ceramic Coffee Mug",
        productBy: "Keaton Larson",
        productStatus: "Shipping",
        badgeColor: "warning",
    },
];

const newcustomers = [
    {
        id: 1,
        productImage: avatar2,
        productName: "Tommy Carey",
        date: "02 Jan, 2023"
    },
    {
        id: 2,
        productImage: avatar1,
        productName: "Cassius Brock",
        date: "24 Nov, 2022"
    },
    {
        id: 3,
        productImage: avatar3,
        productName: "Gabrielle Holden",
        date: "17 Nav, 2022"
    },
    {
        id: 4,
        productImage: avatar5,
        productName: "Alfred Hurst",
        date: "18 Dec, 2021"
    },
    {
        id: 5,
        productImage: avatar6,
        productName: "Kristina Hooper",
        date: "04 Oct, 2022"
    },
    {
        id: 6,
        productImage: avatar8,
        productName: "Jacques Leon",
        date: "02 Jan, 2023"
    },
    {
        id: 7,
        productImage: avatar7,
        productName: "Edward Rogers",
        date: "25 Nov, 2022"
    },
    {
        id: 8,
        productImage: avatar10,
        productName: "Alina Holland",
        date: "11 Jan, 2023"
    },
];

const allRevenueChartData = [{
    name: "Orders",
    type: 'line',
    data: [180, 274, 346, 290, 370, 420, 490, 542, 510, 580, 636, 745]
},
{
    name: "Refunds",
    type: 'area',
    data: [100, 154, 302, 411, 300, 284, 273, 232, 187, 174, 152, 122]
},
{
    name: "Earnings",
    type: 'line',
    data: [260, 360, 320, 345, 436, 527, 641, 715, 832, 794, 865, 933]
}]

const monthRevenueChartData = [{
    name: "Orders",
    type: 'line',
    data: [170, 254, 326, 260, 350, 400, 470, 522, 500, 570, 606, 725]
},
{
    name: "Refunds",
    type: 'area',
    data: [90, 124, 152, 371, 290, 244, 253, 232, 167, 154, 132, 112]
},
{
    name: "Earnings",
    type: 'line',
    data: [250, 350, 310, 335, 426, 517, 631, 705, 822, 774, 835, 923]
}]

const halfYearRevenueChartData = [{
    name: "Orders",
    type: 'line',
    data: [160, 254, 336, 310, 390, 450, 510, 572, 540, 600, 656, 765]
},
{
    name: "Refunds",
    type: 'area',
    data: [120, 157, 322, 491, 320, 324, 293, 262, 207, 194, 172, 132]
},
{
    name: "Earnings",
    type: 'line',
    data: [290, 310, 380, 345, 456, 547, 631, 735, 852, 824, 895, 953]
}]

const yearRevenueChartData = [{
    name: "Orders",
    type: 'line',
    data: [230, 344, 346, 310, 450, 470, 510, 642, 550, 600, 646, 765]
},
{
    name: "Refunds",
    type: 'area',
    data: [120, 174, 342, 431, 320, 344, 293, 262, 217, 214, 172, 142]
},
{
    name: "Earnings",
    type: 'line',
    data: [290, 390, 350, 375, 456, 547, 671, 745, 852, 814, 885, 953]
}]

export { recentOrders, stockReport, productDelivery, newcustomers, allRevenueChartData, monthRevenueChartData, halfYearRevenueChartData, yearRevenueChartData };
export type { RecentOrders };
